<template>
  <v-menu
    v-model="menu_ativo"
    offset-y
    :close-on-content-click="false"
    open-on-hover
    open-delay="1500"
    close-delay="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex" v-bind="attrs" v-on="on">
        <v-btn icon @click="$emit('click', $event)">
          <v-icon>$HomeSwitchOutline</v-icon>
        </v-btn>

        <div
          v-if="produto.qtd_pedidos_filial_com_produto > 0"
          v-text="produto.qtd_pedidos_filial_com_produto"
          class="position-absolute font-11 ml-6 mt-n1 text-gray-300"
        />
      </div>
    </template>

    <div v-if="produto.qtd_pedidos_filial_com_produto > 0" class="bg-white px-2 py-3">
      <p
        class="ma-0 font-14 font-weight-medium text-gray-900"
        v-text="`O produto está em ${produto.qtd_pedidos_filial_com_produto} carrinho${produto.qtd_pedidos_filial_com_produto > 1 ? 's' : ''}`"
      />

      <template v-if="carregando">
        <div class="d-flex py-2">
          <v-progress-circular
            color="red"
            indeterminate
            width="2"
            size="25"
            class="mx-auto"
          />
        </div>

        <p class="ma-0 text-center font-12 text-gray-200">Carregando... aguarde.</p>
      </template>

      <div v-else class="font-12 pl-1">
        <div v-for="(carrinho, key) in carrinhos" :key="key">
          {{ `Filial ${carrinho.filial} com ${Helpers.formatarValor(carrinho.qtde_pedido)}` }}
          {{ embalagemMasterAtivada ? produto.unidade_master : produto.unidade_compra }}
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import {buscarDetalhamentoCarrinhosOndeProdutoEsta} from "@/api/compra";
import {logout} from "@/helpers";

export default {
  name: "DetalhamentoCarrinhosProduto",
  props: {
    produto: Object
  },
  data: () => ({
    menu_ativo: false,
    carregando: false,
    carrinhos: []
  }),
  computed: {
    embalagemMasterAtivada() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"]
    }
  },
  watch: {
    menu_ativo() {
      if (this.menu_ativo) {
        setTimeout(() => this.buscarDetalhamentoCarrinhos(), 100);
      }
    }
  },
  methods: {
    buscarDetalhamentoCarrinhos() {
      if (this.carrinhos.length > 0 || this.produto.qtd_pedidos_filial_com_produto === 0) return;

      this.carregando = true;

      const parametros = {
        id_grupo: this.produto.id_grupo,
        idproduto: this.produto.idproduto
      };

      buscarDetalhamentoCarrinhosOndeProdutoEsta(parametros)
        .then(carrinhos => {
          this.carrinhos = carrinhos;
          this.carregando = false;
        })
        .catch(logout)
    }
  }
}
</script>

<style scoped>

</style>
